import { motion } from "framer-motion";
import { SMILEYS } from "../lib/constants";

export const SmileyRating = ({ value, onChange }) => (
  <div className="grid grid-cols-5 gap-2 sm:gap-3" role="radiogroup" data-testid="smiley-rating">
    {SMILEYS.map((s) => {
      const active = value === s.value;
      return (
        <motion.button
          type="button"
          key={s.value}
          role="radio"
          aria-checked={active}
          data-testid={`rating-smiley-${s.value}`}
          onClick={() => onChange(s.value)}
          whileHover={{ y: -4, scale: 1.04 }}
          whileTap={{ scale: 0.92 }}
          animate={active ? { scale: [1, 1.12, 1.04] } : { scale: 1 }}
          transition={{ type: "spring", stiffness: 380, damping: 18 }}
          style={active ? { borderColor: s.color, boxShadow: `0 12px 30px -10px ${s.color}88` } : undefined}
          className={`group relative flex flex-col items-center gap-1 rounded-2xl border-2 px-1 py-3 sm:py-4 transition-colors ${
            active ? `${s.bg}` : "border-transparent bg-white/70 hover:bg-white"
          }`}
        >
          <motion.span
            className={`text-4xl sm:text-5xl select-none transition-[filter] duration-200 ${active || !value ? "" : "grayscale-[60%] opacity-70 group-hover:grayscale-0 group-hover:opacity-100"}`}
            animate={active ? { rotate: [0, -10, 10, 0] } : { rotate: 0 }}
            transition={{ duration: 0.5 }}
          >
            {s.emoji}
          </motion.span>
          <span className="text-xs sm:text-sm font-bold" style={{ color: active ? s.color : "#475569" }}>{s.label}</span>
          <span className="hidden sm:block text-[10px] uppercase tracking-wider text-slate-400">{s.value} · {s.sub}</span>
        </motion.button>
      );
    })}
  </div>
);
